import request from '@/utils/request'

/** 根据中央气象台返回的中文天气描述映射 Element UI 图标 */
export function resolveWeatherDisplayByLabel(label) {
  const t = (label || '').trim()
  if (!t) {
    return { label: '晴', icon: 'el-icon-sunny', color: '#faad14' }
  }
  if (t.includes('雷')) {
    return { label: t, icon: 'el-icon-lightning', color: '#722ed1' }
  }
  if (t.includes('雪')) {
    return { label: t, icon: 'el-icon-cloudy', color: '#69b1ff' }
  }
  if (t.includes('雨') || t.includes('降水')) {
    return { label: t, icon: 'el-icon-heavy-rain', color: '#1677ff' }
  }
  if (t.includes('雾') || t.includes('霾')) {
    return { label: t, icon: 'el-icon-cloudy', color: '#c9cdd4' }
  }
  if (t.includes('阴')) {
    return { label: t, icon: 'el-icon-cloudy', color: '#86909c' }
  }
  if (t.includes('多云')) {
    return { label: t, icon: 'el-icon-cloudy-and-sunny', color: '#86909c' }
  }
  if (t.includes('晴')) {
    return { label: t, icon: 'el-icon-sunny', color: '#faad14' }
  }
  return { label: t, icon: 'el-icon-partly-cloudy', color: '#86909c' }
}

/** 中央气象台站点 ID，默认上海市区 WwcJd */
const STORAGE_KEY = 'Gas-Weather-StationId'

export function getWeatherStationId() {
  try {
    const id = localStorage.getItem(STORAGE_KEY)
    if (id && id.trim()) return id.trim()
  } catch (e) { /* ignore */ }
  return 'WwcJd'
}

/**
 * 通过后端代理拉取中央气象台（NMC）实况天气
 */
export async function fetchCurrentWeather() {
  const stationId = getWeatherStationId()
  const res = await request.get('/gas/weather/current', { params: { stationId } })
  const d = res.data || {}
  const display = resolveWeatherDisplayByLabel(d.label)
  const temp = d.temp != null ? Number(d.temp) : null
  return {
    ...display,
    temp: temp != null && !Number.isNaN(temp) ? Math.round(temp) : null,
    city: d.city,
    stationId: d.stationId || stationId,
    source: d.source || 'nmc'
  }
}

export default {
  fetchCurrentWeather,
  resolveWeatherDisplayByLabel,
  getWeatherStationId
}
